/* Gentle Beauty — footer: mobile accordions + back to top. */
(function () {
  'use strict';
  if (customElements.get('gb-footer')) return;

  var mqDesktop = window.matchMedia('(min-width: 750px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  customElements.define('gb-footer', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.accordions = Array.prototype.slice.call(this.querySelectorAll('[data-gb-footer-acc]'));
      this.accordionMode = this.classList.contains('gb-footer--accordion');

      this.onSummaryClick = function (e) {
        var summary = e.target.closest('summary');
        if (!summary || !self.contains(summary)) return;
        if (mqDesktop.matches || !self.accordionMode) e.preventDefault();
      };
      this.addEventListener('click', this.onSummaryClick);

      this.onBreakpoint = function () { self.syncAccordions(); };
      if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', this.onBreakpoint);
      else if (mqDesktop.addListener) mqDesktop.addListener(this.onBreakpoint);
      this.syncAccordions();

      this.onTop = function (e) {
        if (!e.target.closest('[data-gb-back-to-top]')) return;
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: mqReduce.matches ? 'auto' : 'smooth' });
        var skip = document.querySelector('.skip-to-content-link') || document.body;
        if (skip && skip.focus) skip.focus({ preventScroll: true });
      };
      this.addEventListener('click', this.onTop);

      this.onBlockSelect = function (e) {
        if (!self.contains(e.target)) return;
        var acc = e.target.querySelector('[data-gb-footer-acc]');
        if (acc) acc.open = true;
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      if (mqDesktop.removeEventListener) mqDesktop.removeEventListener('change', this.onBreakpoint);
      else if (mqDesktop.removeListener) mqDesktop.removeListener(this.onBreakpoint);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    syncAccordions() {
      var open = mqDesktop.matches || !this.accordionMode;
      this.accordions.forEach(function (d) { d.open = open; });
    }
  });
})();
